import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getContext } from 'svelte';

var root = $.from_html(`<button><!></button>`);

export default function Select_trigger($$anchor, $$props) {
	$.push($$props, true);

	let className = $.prop($$props, 'class', 3, ''),
		rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy', 'id', 'class', 'children']);

	const select = getContext('select');

	function toggle() {
		select.setOpen(!select.isOpen());
	}

	var button = root();

	$.attribute_effect(button, () => ({
		type: 'button',
		id: $$props.id,
		onclick: toggle,
		class: `flex w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring ${className() ?? ''}`,
		...rest
	}));

	var node = $.child(button);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(button);
	$.append($$anchor, button);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsic2VsZWN0LXRyaWdnZXIuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG4gIGltcG9ydCB7IGdldENvbnRleHQgfSBmcm9tICdzdmVsdGUnO1xuXG4gIGxldCB7XG4gICAgaWQsXG4gICAgY2xhc3M6IGNsYXNzTmFtZSA9ICcnLFxuICAgIGNoaWxkcmVuLFxuICAgIC4uLnJlc3RcbiAgfToge1xuICAgIGlkPzogc3RyaW5nO1xuICAgIGNsYXNzPzogc3RyaW5nO1xuICAgIGNoaWxkcmVuPzogYW55O1xuICAgIFtrZXk6IHN0cmluZ106IGFueTtcbiAgfSA9ICRwcm9wcygpO1xuXG4gIGNvbnN0IHNlbGVjdCA9IGdldENvbnRleHQ8e1xuICAgIGlzT3BlbjogKCkgPT4gYm9vbGVhbjtcbiAgICBzZXRPcGVuOiAob3BlbjogYm9vbGVhbikgPT4gdm9pZDtcbiAgfT4oJ3NlbGVjdCcpO1xuXG4gIGZ1bmN0aW9uIHRvZ2dsZSgpIHtcbiAgICBzZWxlY3Quc2V0T3Blbighc2VsZWN0LmlzT3BlbigpKTtcbiAgfVxuPC9zY3JpcHQ+XG5cbjxidXR0b25cbiAgdHlwZT1cImJ1dHRvblwiXG4gIHtpZH1cbiAgb25jbGljaz17dG9nZ2xlfVxuICBjbGFzcz1cImZsZXggdy1mdWxsIGl0ZW1zLWNlbnRlciBqdXN0aWZ5LWJldHdlZW4gcm91bmRlZC1tZCBib3JkZXIgYm9yZGVyLWlucHV0IGJnLWJhY2tncm91bmQgcHgtMyBweS0yIHRleHQtc20gcmluZy1vZmZzZXQtYmFja2dyb3VuZCBmb2N1czpvdXRsaW5lLW5vbmUgZm9jdXM6cmluZy0yIGZvY3VzOnJpbmctcmluZyB7Y2xhc3NOYW1lfVwiXG4gIHsuLi5yZXN0fVxuPlxuICB7QHJlbmRlciBjaGlsZHJlbj8uKCl9XG48L2J1dHRvbj5cbiJdLCJtYXBwaW5ncyI6Ijs7U0FDVyxVQUFVLFFBQVEsUUFBUTs7OzswREFEckMsQ0FBQzs7O0tBS1UsU0FBUywrQkFBRyxFQUFFO0VBRWxCLElBQUk7O09BUUgsTUFBTSxHQUFHLFVBQVUsQ0FHdEIsUUFBUTs7VUFFRixNQUFNLEdBQUcsQ0FBQztFQUNqQixNQUFNLENBQUMsT0FBTyxFQUFFLE1BQU0sQ0FBQyxNQUFNO0NBQy9CLENBQUM7Ozs7Ozs7V0FNUSxNQUFNOzJMQUN3SyxTQUFTO0tBQzVMLElBQUk7Ozs7Ozs7OztBQVBYLENBQUMifQ==